<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :click-not-close="true"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="menu-do-dialog"
  >
    <div class="form-content">
      <menu-form
        ref="outform"
        @submit="submit"
      ></menu-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import { addMenu } from "@/api/sys/menu";
import menuForm from "@/components/sys/menu/menuForm";
export default {
  name: "addDialog",
  components: {
    menuForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '添加菜单'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel(){
      this.beforeClose();
    },
    confirm(){
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form){
      // todo
      // this.$emit('submit',form);
      let params = {
        'type': form.type,
        'name': form.name,
        'parentId': form.parentId,
        'url': form.url,
        'perms': form.perms,
        'orderNum': form.orderNum,
        'icon': form.icon
      }
      addMenu(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>
<style>
@media screen and (min-width: 768px) {
  .menu-do-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
